import developmentConfig from '../../config/development.json';
import productionConfig from '../../config/production.json';
import qaConfig from '../../config/qa.json';
import testConfig from '../../config/test.json';

export interface ServiceConfig {
  host: string;
  base: string;
  path: Record<string, string>;
}

export interface Config {
  defaultLanguage: string;
  service: {
    choice: ServiceConfig;
    cmp: ServiceConfig;
    cmpApi: ServiceConfig;
  };
  auth: {
    userPoolId: string;
    clientId: string;
    secureTokenStoreUrl: string;
    secureTokenStoreCleanUp: string;
    authUrl: string;
  };
}

export const getEnvironment = (): string => {
  // Check Vite environment variables first
  if (import.meta.env.VITE_NODE_ENV) {
    return import.meta.env.VITE_NODE_ENV;
  }

  // Fallback to standard NODE_ENV
  if (import.meta.env.NODE_ENV) {
    return import.meta.env.NODE_ENV;
  }

  // Default to development
  return 'development';
};

export const getConfig = (): Config => {
  const environment = getEnvironment();
  console.log('environment', environment, testConfig);

  switch (environment) {
    case 'production':
      return productionConfig as Config;
    case 'staging':
    case 'qa':
      return qaConfig as Config;
    case 'test':
      return testConfig as Config;
    case 'development':
    case 'develop':
    default:
      return developmentConfig as Config;
  }
};

export const config = getConfig();

// Generic function that takes serviceName and endpointName and returns complete URL
export const getApiUrl = (
  serviceName: keyof Config['service'],
  endpointName: string,
  pathParams?: Record<string, string>,
): string => {
  const service = config.service[serviceName];
  let path = service.path[endpointName];

  if (!path) {
    throw new Error(
      `Path key "${endpointName}" not found for service "${serviceName}"`,
    );
  }

  // Replace path parameters if provided
  if (pathParams) {
    Object.entries(pathParams).forEach(([key, value]) => {
      path = path?.replace(`{${key}}`, value) || '';
    });
  }

  return `${service.host}${service.base}${path}`;
};

export default config;
